import type BABYLON from 'babylonjs';
import type LOADERS from 'babylonjs-loaders';
import type MATERIALS from 'babylonjs-materials';

export interface Globals {
  BABYLON: typeof BABYLON;
  LOADERS: typeof LOADERS;
  MATERIALS: typeof MATERIALS;
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onerror = (err): void => {
      script.onload = null;
      script.onerror = null;
      reject(err);
    };
    script.onload = (): void => {
      script.onload = null;
      script.onerror = null;
      resolve();
    };
    document.head.appendChild(script);
  });
}

export async function loadGlobals(
  globalUrls: Partial<Record<keyof Globals, string>> = {}
): Promise<Globals> {
  // eslint-disable-next-line no-restricted-syntax
  for (const name of ['BABYLON', 'LOADERS', 'MATERIALS'] as const) {
    const url = globalUrls[name];
    // eslint-disable-next-line no-await-in-loop
    if (!(name in globalThis) && url) await loadScript(url);
    if (!(name in globalThis)) throw new Error(`${name} is undefined`);
  }
  return globalThis as unknown as Globals;
}
